import React, { createContext, useCallback, useEffect, useState } from 'react';

import AnalyticsHelper from 'helpers/AnalyticsHelper';
import ShopSettingsService from 'services/ShopSettingsService';
import ShopService from 'services/ShopService';
import NotificationsService from 'services/Notifications';
import NotificationsDialog from 'components/popups/NotificationsDialog';

export const ShopContext = createContext();

function ShopProvider(props) {
  const [shop, setShop] = useState(null);
  const [shops, setShops] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [cachedAccountHeads, setCachedAccountHeads] = useState(null);
  const [cachedLedgers, setCachedLedgers] = useState({});

  const loadShops = useCallback(async () => {
    const res = await ShopService.getShops();
    setShops(res || []);
  }, []);

  const loadShopProfile = useCallback(async () => {
    const res = await ShopSettingsService.loadShopProfile();
    setShop(res);
    if (res?.id) {
      AnalyticsHelper.setShopInAnalytics(res);
    }
  }, []);

  const loadNotifications = useCallback(async () => {
    const res = await NotificationsService.getNotifications();
    setNotifications(res);
  }, []);

  const handleCloseNotification = async (notification = selectedNotification) => {
    setSelectedNotification(null);
    setNotifications((prevNotifications) =>
      prevNotifications.map((notif) => (notif.id === notification.id ? { ...notif, read: true } : notif))
    );
    await NotificationsService.markAsReadNotification(notification?.id);
  };

  useEffect(() => {
    loadShopProfile();
    loadNotifications();
  }, [loadShopProfile, loadNotifications]);

  useEffect(() => {
    if (shops === null) {
      loadShops();
    }
  }, [loadShops, shops]);

  return (
    <ShopContext.Provider
      value={{
        shop,
        shops,
        notifications,
        setShop,
        loadShopProfile,
        loadShops,
        handleCloseNotification,
        setSelectedNotification,
        cachedAccountHeads,
        setCachedAccountHeads,
        cachedLedgers,
        setCachedLedgers,
      }}
    >
      {props.children}
      <ShopManagement selectedNotification={selectedNotification} handleCloseNotification={handleCloseNotification} />
    </ShopContext.Provider>
  );
}

function ShopManagement({ selectedNotification, handleCloseNotification }) {
  return (
    <>
      {selectedNotification && (
        <NotificationsDialog handleCloseNotification={handleCloseNotification} notification={selectedNotification} />
      )}
    </>
  );
}

export default ShopProvider;
